import React from 'react';
import PropTypes from 'prop-types';

export const IconMenuOrder = ({ color, size, ...props }) => {
    // SVG downloaded from Tabler icon library
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-menu-order"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 10h16" />
            <path d="M4 14h16" />
            <path d="M9 18l3 3l3 -3" />
            <path d="M9 6l3 -3l3 3" />
        </svg>
    );
};

IconMenuOrder.propTypes = {
    color: PropTypes.string,
    size: PropTypes.number
};

IconMenuOrder.defaultProps = {
    color: '#000000',
    size: 24
};
